import { render } from "./DummyTaskItem.vue?vue&type=template&id=88a8f340&scoped=true"
const script = {}

import "./DummyTaskItem.vue?vue&type=style&index=0&id=88a8f340&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88a8f340"]])

export default __exports__